module.exports = __webpack_public_path__ + "static/img/voice_assistant.fd5137f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/voice_assistant.png
// module id = qNgg
// module chunks = 1